import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import Swiper from 'swiper';

@Component({
  selector: 'app-image-visor',
  templateUrl: './image-visor.component.html',
  styleUrls: ['./image-visor.component.scss']
})
export class ImageVisorComponent {
  @Output() exitFullScreen = new EventEmitter<boolean>();
  @Input() initialSlide = 0
  @ViewChild('swiperContainer', { static: false }) swiperContainer!: ElementRef<{ swiper: Swiper }>;

  ngAfterViewInit() {
    if (this.swiperContainer?.nativeElement?.swiper) {
      setTimeout(() => {
        this.swiperContainer.nativeElement.swiper.slideTo(this.initialSlide);
      }, 100);
    }
  }
  
  exitFull(state:boolean) {
    this.exitFullScreen.emit(state);
  }

  @HostListener('document:keydown', ['$event'])
  keydown(event: KeyboardEvent) {
    if (event.key === "Escape") {
      this.exitFull(true);
    }
  }
  
  onPrev() {
    this.swiperContainer.nativeElement.swiper.slidePrev();
  }
  
  onNext() {
    this.swiperContainer.nativeElement.swiper.slideNext();
  }
}
